import React from 'react'
import { Service1 } from '../ServiceSec1/Service1'
import { Service2 } from '../ServiceSec2/Service2/Service2'
import MarqueeEffect from '../Marquee/MarqueeEeffect'

const Services = () => {
  return (
   <><Service1 />
   <MarqueeEffect/>
   <Service2 /></>
  )
}

export default Services